import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import {
  apiError,
  getList,
  listSuccessful,
  addRecordSuccessful,
  getRecordByIdSuccessful,
} from "./counterCashDepositSlice";
import { postAdd, getParamsList, getList as getById, postEdit, postDelete } from "../../../helpers/Helper";
import { axiosInstance } from "../../../helpers/AxiosHelper";
import { Modal } from "antd";
import { RiCheckboxCircleLine, RiAlertLine } from "react-icons/ri";

function* FetchList({ payload }) {
  var params = {};
  for (const k in payload) {
    if (Object.hasOwnProperty.call(payload, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = payload.sortOrder + payload.currentSort;
      } else if (payload[k] != "" && k != null && k != "no_of_pages") {
        params[k] = payload[k];
      }
    }
  }
  try {
    const response = yield call(getParamsList, "/payments/counter-cash-deposits/", params);
    yield put(listSuccessful({ response }));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* Add({ payload }) {
  try {
    const { obj, profileObj } = payload;
    console.log("Counter Cash Deposit Payload:", JSON.stringify(obj, null, 2));
    if (obj.id == 0) {
      const response = yield call(postAdd, "/payments/counter-cash-deposits/", obj);
      console.log("Add Response:", response);
      if (response.status === 201 || response.status === 200) {
        if (profileObj?.attachment && typeof profileObj.attachment !== 'string') {
          const formData = new FormData();
          formData.append('attachment', profileObj.attachment);
          yield call([axiosInstance, 'put'], "/payments/counter-cash-deposits/attachment/" + response.data.id, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
        }
        Modal.success({
          icon: <span className="remix-icon"><RiCheckboxCircleLine /></span>,
          title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
          content: <p className="hp-p1-body hp-text-color-black-80">Counter Cash Deposit Added Successfully!</p>,
        });
        yield put(getList({ page: 1, search: "", page_size: 10 }));
        yield put(addRecordSuccessful());
      } else {
        Modal.error({
          icon: <span className="remix-icon"><RiAlertLine /></span>,
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: <p className="hp-p1-body hp-text-color-black-80">Unable to add. Please try again!</p>,
        });
      }
    } else {
      const response = yield call(postEdit, "/payments/counter-cash-deposits/" + obj.id, obj);
      if (response.status === 200 || response.status === 201) {
        if (profileObj?.attachment && typeof profileObj.attachment !== 'string') {
          const formData = new FormData();
          formData.append('attachment', profileObj.attachment);
          yield call([axiosInstance, 'put'], "/payments/counter-cash-deposits/attachment/" + obj.id, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
        }
        Modal.success({
          icon: <span className="remix-icon"><RiCheckboxCircleLine /></span>,
          title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
          content: <p className="hp-p1-body hp-text-color-black-80">Counter Cash Deposit Updated Successfully!</p>,
        });
        yield put(getList({ page: 1, search: "", page_size: 10 }));
        yield put(addRecordSuccessful());
      } else {
        Modal.error({
          icon: <span className="remix-icon"><RiAlertLine /></span>,
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: <p className="hp-p1-body hp-text-color-black-80">Unable to update. Please try again!</p>,
        });
      }
    }
  } catch (error) {
    Modal.error({
      icon: <span className="remix-icon"><RiAlertLine /></span>,
      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: <p className="hp-p1-body hp-text-color-black-80">Server side issue!</p>,
    });
    console.log("Counter Cash Deposit Error:", error);
    console.log("Error Response:", error?.response?.data);
    yield put(apiError(error));
  }
}

function* Delete({ payload }) {
  try {
    const response = yield call(postDelete, "/payments/counter-cash-deposits/" + payload);
    if (response.status === 204) {
      Modal.success({
        icon: <span className="remix-icon"><RiCheckboxCircleLine /></span>,
        title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
        content: <p className="hp-p1-body hp-text-color-black-80">Counter Cash Deposit deleted!</p>,
      });
      yield put(getList({ page: 1, search: "", page_size: 10 }));
    } else {
      Modal.error({
        icon: <span className="remix-icon"><RiAlertLine /></span>,
        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: <p className="hp-p1-body hp-text-color-black-80">Unable to delete!</p>,
      });
    }
  } catch (error) {
    Modal.error({
      icon: <span className="remix-icon"><RiAlertLine /></span>,
      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: <p className="hp-p1-body hp-text-color-black-80">Server side issue!</p>,
    });
    yield put(apiError(error));
  }
}

function* FetchById({ payload }) {
  try {
    const response = yield call(getById, "/payments/counter-cash-deposits/" + payload);
    yield put(getRecordByIdSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* CounterCashDepositSaga() {
  yield all([
    fork(function* () { yield takeEvery("counterCashDeposit/getList", FetchList); }),
    fork(function* () { yield takeEvery("counterCashDeposit/addRecord", Add); }),
    fork(function* () { yield takeEvery("counterCashDeposit/deleteRecord", Delete); }),
    fork(function* () { yield takeEvery("counterCashDeposit/getRecordById", FetchById); }),
  ]);
}

export default CounterCashDepositSaga;
